


































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import JobApplication from '@/domain/selective-process/entity/job/job-application.entity';
import Headers from './jobs-table-header.json';

@Component
export default class JobListComponent extends Vue {
  @Prop({
    type: Array,
    required: true,
  }) jobs!: JobApplication[];

  headers = Headers;

  openLink(link: string) {
    window.open(link, '_blank');
  }

  formatDate(date: string): string {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }
}
